// extracted by mini-css-extract-plugin
export default {"input_text":"GroupNameInput_input_text__N4tfo","input_text_edit":"GroupNameInput_input_text_edit__kGiIr"};